// components/MemberCard.tsx - Version corrigée avec selfie transmis
import React from 'react';
import { useMemberCard } from '../../hooks/useMemberCard';
import MemberCardDisplay from './MemberCardDisplay';
import MemberActions from './MemberActions';
import QRCodeModal from './QRCodeModal';
import ShareSection from './ShareSection';

interface MemberCardProps {
    memberData: {
        id?: string;
        member_number: string;
        first_name: string;
        last_name: string;
        email?: string;
        phone: string;
        nip?: string;
        city: string;
        province: string;
        country?: string;
        date_of_birth?: string;
        place_of_birth?: string;
        profession?: string;
        referral_code: string;
        created_at: string;
        badges?: string[];
        selfie_url?: string;
        signature_data?: string;
    };
    signatureData?: string | null;
    selfie?: string | null;
    onClose?: () => void;
}

const MemberCard: React.FC<MemberCardProps> = ({
                                                   memberData,
                                                   signatureData,
                                                   selfie,
                                                   onClose
                                               }) => {


    // Utiliser le hook centralisé
    const {
        // États
        qrCodeUrl,
        showQRModal,
        isDownloadingCard,
        isDownloadingPDF,
        downloadError,
        pdfError,
        copySuccess,

        // Fonctions principales
        downloadMemberCard,
        generateAdhesionFormPDF,
        copyReferralLink,
        shareWhatsApp,
        shareToSocial,

        // Fonctions QR Code
        openQRModal,
        closeQRModal,
        downloadQRCode,

        // Fonctions utilitaires
        clearDownloadError,
        clearPdfError,
        generateShareLinks
    } = useMemberCard(memberData);

    // Préparer les données pour le PDF (avec selfie externe si fourni)
    const handleGeneratePDF = () => {
        generateAdhesionFormPDF(selfie);
    };

    // Obtenir les liens de partage
    const shareLinks = generateShareLinks();

    return (
        <div className="space-y-8">


            {/* Titre */}
            <h2 className="text-2xl font-semibold text-gray-900 mb-6 text-center">
                Votre Carte de Membre
            </h2>

            {/* Carte de membre - IMPORTANT: Passer le selfie ! */}
            <MemberCardDisplay
                memberData={memberData}
                qrCodeUrl={qrCodeUrl}
                onQRClick={openQRModal}
                selfie={selfie} // ← AJOUT CRUCIAL: Passer le selfie au composant d'affichage
                signatureData={signatureData} // ← AJOUT: Passer aussi la signature si nécessaire
            />

            {/* Boutons d'action */}
            <MemberActions
                isDownloadingCard={isDownloadingCard}
                isDownloadingPDF={isDownloadingPDF}
                downloadError={downloadError}
                pdfError={pdfError}
                onDownloadCard={downloadMemberCard}
                onGeneratePDF={handleGeneratePDF}
                onClearDownloadError={clearDownloadError}
                onClearPdfError={clearPdfError}
            />

            {/* Section de partage */}
            {shareLinks && (
                <ShareSection
                    referralLink={shareLinks.referralLink}
                    copySuccess={copySuccess}
                    onCopyLink={copyReferralLink}
                    onShareWhatsApp={shareWhatsApp}
                    onShareSocial={shareToSocial}
                    referralCode={memberData.referral_code}
                />
            )}

            {/* Modal QR Code */}
            <QRCodeModal
                isOpen={showQRModal}
                onClose={closeQRModal}
                qrCodeUrl={qrCodeUrl}
                memberData={{
                    first_name: memberData.first_name,
                    last_name: memberData.last_name,
                    member_number: memberData.member_number,
                    referral_code: memberData.referral_code
                }}
                onDownloadQR={downloadQRCode}
            />

            {/* Bouton fermer si fourni */}
            {onClose && (
                <div className="text-center">
                    <button
                        onClick={onClose}
                        className="bg-gray-600 text-white px-8 py-3 rounded-lg hover:bg-gray-700 transition-colors font-semibold"
                    >
                        Fermer
                    </button>
                </div>
            )}
        </div>
    );
};

export default MemberCard;
